import { RouteConfig } from 'vue-router';
import MswAccessMgmt from './msw-accessmgmt.vue';

const route: RouteConfig = {
  path: 'mssp-access-management',
  name: 'msspAccessManagement',
  component: MswAccessMgmt,
};

export function getDefaultParams() {
  return {};
}

export default route;
